package com.fantasytenis.shared.domain.notifications.entity

/**
 * Notification type enum matching backend.
 */
enum class NotificationType {
    CONTEST_COMPLETED,
    PAYOUT_RECEIVED,
    STREAK_AT_RISK,
    ACHIEVEMENT_UNLOCKED,
    CONTEST_REMINDER,
    GENERAL
}

/**
 * Domain entity for a user notification.
 */
data class NotificationEntity(
    val id: String,
    val userId: String,
    val type: NotificationType,
    val title: String,
    val message: String,
    val read: Boolean,
    val contestId: String?,
    val entryId: String?,
    val metadata: Map<String, Any>?,
    val createdAt: String,
    val updatedAt: String
) {
    /**
     * Get the icon for this notification type.
     */
    val icon: String get() = when (type) {
        NotificationType.CONTEST_COMPLETED -> "\uD83C\uDFC6" // 🏆
        NotificationType.PAYOUT_RECEIVED -> "\uD83D\uDCB0" // 💰
        NotificationType.STREAK_AT_RISK -> "\uD83D\uDD25" // 🔥
        NotificationType.ACHIEVEMENT_UNLOCKED -> "\u2B50" // ⭐
        NotificationType.CONTEST_REMINDER -> "\u23F0" // ⏰
        NotificationType.GENERAL -> "\uD83D\uDCE2" // 📢
    }

    /**
     * Get the accent color for this notification type.
     */
    val accentColor: String get() = when (type) {
        NotificationType.CONTEST_COMPLETED -> "#FFD700" // Gold
        NotificationType.PAYOUT_RECEIVED -> "#4CAF50" // Green
        NotificationType.STREAK_AT_RISK -> "#FF9800" // Orange
        NotificationType.ACHIEVEMENT_UNLOCKED -> "#9C27B0" // Purple
        NotificationType.CONTEST_REMINDER -> "#2196F3" // Blue
        NotificationType.GENERAL -> "#607D8B" // Grey
    }

    /**
     * Check if this notification has associated navigation.
     */
    val hasNavigation: Boolean get() = contestId != null || entryId != null
}

/**
 * Paginated response for notifications.
 */
data class NotificationPage(
    val notifications: List<NotificationEntity>,
    val total: Int,
    val hasMore: Boolean
)
